<ng-container
  [ngTemplateOutlet]="template$ | async"
  [ngTemplateOutletContext]="{ $implicit: this }"
></ng-container>
